<template>
  <div
    v-if="legends.length !== 0"
    class="position-absolute map-info-card background-white"
  >
    <v-row no-gutters class="pa-2 d-flex text-center" style="max-width: 170px">
      <v-col cols="12" class="text-body-2 text-capitalize">
        -- information --
      </v-col>
      <v-col cols="12" class="text-caption" v-if="legendType == 'trip'">
        <v-row no-gutters>
          <v-col cols="2" class="d-flex justify-center align-center">
            <div
              style="height: 4px; background: #3498eb; width: 80%"
              class="my-2"
            ></div>
          </v-col>
          <v-col cols="10" class="d-flex justify-start">
            <span
              class="my-1 mx-2 text-caption float-left text-capitalize"
              :class="
                isVisiblePlanned != true ? 'text-decoration-line-through' : ''
              "
              style="cursor: pointer"
              @click="routeDisplay('planned')"
            >
              planned route
            </span>
          </v-col>
          <v-col cols="2" class="d-flex justify-center align-center">
            <div
              style="height: 4px; background: red; width: 80%"
              class="my-2"
            ></div>
          </v-col>
          <v-col cols="10" class="d-flex justify-start">
            <span
              :class="
                isVisibleActual != true ? 'text-decoration-line-through' : ''
              "
              class="my-1 mx-2 text-caption float-left text-capitalize"
              @click="routeDisplay('actual')"
              style="cursor: pointer"
            >
              actual route
            </span>
          </v-col>
          <v-col cols="12" class="text-caption">
            <div>
              <v-img
                width="11%"
                style="margin-left: 2px !important"
                class="ma-1 float-left"
                :src="TruckIcon"
              ></v-img>
              <span class="my-1 mx-2 text-caption float-left text-capitalize">
                {{ fleetModule.driver }} location
              </span>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="text-caption">
        <slot></slot>
      </v-col>
      <v-col
        cols="12"
        class="text-caption"
        v-if="legendType == 'trip' || legendType == 'orders'"
      >
        <v-row no-gutters>
          <v-col cols="12" v-for="legend in tripLegend" :key="legend.text">
            <div>
              <v-img
                width="8%"
                class="ma-1 float-left"
                :src="legend.marker"
              ></v-img>
              <span class="my-1 mx-2 text-caption float-left text-capitalize">
                {{ legend.text }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="text-caption" v-if="legendType == 'orders'">
        <v-row no-gutters>
          <v-col cols="12" v-for="(legend, index) in legends" :key="index">
            <div>
              <v-img
                width="8%"
                class="ma-1 float-left"
                :src="legend.marker"
              ></v-img>
              <span class="my-1 mx-2 text-caption float-left text-capitalize">
                {{ legend.text }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        class="text-caption"
        v-if="legendType == 'planned_unplanned_orders'"
      >
        <v-row no-gutters>
          <v-col cols="12">
            <div @click="unplannedLocation">
              <v-img
                width="8%"
                class="ma-1 float-left"
                :src="UnplannedLocation"
              ></v-img>
              <span
                class="my-1 mx-2 text-caption float-left text-capitalize"
                :class="
                  !isVisibleUnplanned ? 'text-decoration-line-through' : ''
                "
              >
                Unplanned {{ orderModule.order }}
              </span>
            </div>
          </v-col>
          <v-col cols="12">
            <div @click="plannedLocation">
              <v-img
                width="8%"
                class="ma-1 float-left"
                :src="PlannedLocation"
              ></v-img>
              <span
                class="my-1 mx-2 text-caption float-left text-capitalize"
                :class="!isVisiblePlanned ? 'text-decoration-line-through' : ''"
              >
                Planned {{ orderModule.order }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        class="text-caption"
        v-if="legendType == 'serviceable_area'"
      >
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <div style="width: 8%" class="ma-1">
              <div class="square-box yellow-box"></div>
            </div>
            <span class="my-1 mx-2 text-caption float-left text-capitalize">
              default area
            </span>
          </v-col>
          <v-col cols="12" class="d-flex">
            <div style="width: 8%" class="ma-1">
              <div class="square-box green-box"></div>
            </div>
            <span class="my-1 mx-2 text-caption float-left text-capitalize">
              new area
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        class="text-caption"
        v-if="legendType == 'customer_location_updated'"
      >
        <v-row no-gutters>
          <v-col
            cols="12"
            v-for="legend in customerLocation"
            :key="legend.text"
          >
            <div>
              <v-img
                width="8%"
                class="ma-1 float-left"
                :src="legend.marker"
              ></v-img>
              <span class="my-1 mx-2 text-caption float-left text-capitalize">
                {{ legend.text }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="text-caption" v-if="legendType == 'driver_zone'">
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <div style="width: 8%" class="ma-1">
              <div class="square-box yellow-box"></div>
            </div>
            <span class="my-1 mx-2 text-caption float-left text-capitalize">
              new zone
            </span>
          </v-col>
          <v-col cols="12" class="d-flex">
            <div style="width: 8%" class="ma-1">
              <div class="square-box blue-box"></div>
            </div>
            <span class="my-1 mx-2 text-caption float-left text-capitalize">
              Allocated Zone
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        class="text-caption"
        v-if="legendType == 'region_restriction'"
      >
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <div style="width: 8%" class="ma-1">
              <div class="square-box yellow-box"></div>
            </div>
            <span class="my-1 mx-2 text-caption float-left text-capitalize">
              new zone
            </span>
          </v-col>
          <v-col cols="12" class="d-flex">
            <div style="width: 8%" class="ma-1">
              <div class="square-box blue-box"></div>
            </div>
            <span class="my-1 mx-2 text-caption float-left text-capitalize">
              Allocated Zone
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        class="text-caption"
        v-if="legendType == 'customer_address_location'"
      >
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <div>
              <v-img
                width="8%"
                class="ma-1 float-left"
                :src="customerIcon"
              ></v-img>
              <span class="my-1 mx-2 text-caption float-left text-capitalize">
                customer Address
              </span>
            </div>
          </v-col>
          <v-col cols="12" class="d-flex">
            <div style="width: 8%" class="ma-1">
              <div class="square-box blue-box"></div>
            </div>
            <span class="my-1 mx-2 text-caption float-left text-capitalize">
              Allocated Zone
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="text-caption" v-if="legendType == 'branch'">
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <div>
              <v-img
                width="20%"
                class="ma-1 float-left"
                :src="BranchIcon"
              ></v-img>
              <span class="my-1 ml-2 text-caption float-left text-capitalize">
                {{ configurationModule.branch }}
              </span>
            </div>
          </v-col>
          <v-col cols="12" class="d-flex">
            <div style="width: 8%" class="ma-1">
              <div
                style="
                  border: 2.5px solid red;
                  background-color: yellow;
                  height: 15px;
                  width: 15px;
                "
              ></div>
            </div>
            <span class="my-1 mx-3 text-caption float-left text-capitalize">
              new zone
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        class="text-caption"
        v-if="legendType == 'branchWarehouse'"
      >
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <div>
              <v-img
                width="15%"
                class="ma-1 float-left"
                :src="WarehouseIcon"
              ></v-img>
              <span class="my-1 mx-2 text-caption float-left text-capitalize">
                {{ configurationModule.warehouse }}
              </span>
            </div>
          </v-col>
          <v-col cols="12" class="d-flex">
            <div style="width: 8%" class="ma-1">
              <div class="square-box yellow-box"></div>
            </div>
            <span class="my-1 mx-3 text-caption float-left text-capitalize">
              Serviceable Area
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="text-caption" v-if="legendType == 'warehouse'">
        <v-row no-gutters>
          <v-col cols="12" class="d-flex">
            <div>
              <v-img
                width="15%"
                class="ma-1 float-left"
                :src="WarehouseIcon"
              ></v-img>
              <span class="my-1 mx-2 text-caption float-left text-capitalize">
                {{ configurationModule.warehouse }}
              </span>
            </div>
          </v-col>
          <v-col cols="12" class="d-flex">
            <div style="width: 8%" class="ma-1">
              <div class="square-box yellow-box"></div>
            </div>
            <span class="my-1 mx-3 text-caption float-left text-capitalize">
              new zone
            </span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="text-caption" v-if="legendType == 'operations'">
        <v-row no-gutters>
          <v-col cols="12" class="text-caption">
            <div>
              <v-img
                width="11%"
                style="margin-left: 2px !important"
                class="ma-1 float-left"
                :src="TruckIcon"
              ></v-img>
              <span class="my-1 mx-2 text-caption float-left text-capitalize">
                {{ fleetModule.driver }} location
              </span>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  WarehouseIcon,
  sourceMarker,
  TruckIcon,
  BranchIcon,
  customerIcon,
  destinationsMarker,
  DriverIcon,
  PlannedLocation,
  UnplannedLocation,
  OldLocation,
  UpdatedLocation,
  TripStartLocationIcon,
  TripEndLocationIcon,
} from "@/assets/map/mapIcons.js";
import {
  configurationModule,
  tripModule,
  orderModule,
  fleetModule,
} from "@/utils/moduleMapping";

export default {
  props: {
    legendType: {
      type: String,
      default: "order",
    },
    referenceElement: {
      default: null,
    },
    actualRoute: {
      default: null,
    },
    plannedRoute: {
      default: null,
    },
  },
  data() {
    return {
      configurationModule,
      tripModule,
      orderModule,
      fleetModule,
      WarehouseIcon,
      BranchIcon,
      UnplannedLocation,
      PlannedLocation,
      customerIcon,
      isVisiblePlanned: true,
      isVisibleActual: true,
      TruckIcon: TruckIcon,
      isVisiblePlanned: true,
      isVisibleUnplanned: true,
      tripLegend: [
        { text: "Warehouse", marker: WarehouseIcon },
        { text: "Customer", marker: customerIcon },
        { text: "Branch", marker: BranchIcon },
        { text: "Driver Home", marker: DriverIcon },
        { text: "Trip Start Location", marker: TripStartLocationIcon },
        { text: "Trip End Location", marker: TripEndLocationIcon },
      ],
      // plannedUnplannedLegend: [
      //   { text: "Unplanned Orders", marker: UnplannedLocation },
      //   { text: "Planned Orders", marker: PlannedLocation },
      // ],
      customerLocation: [
        { text: "Previous Location", marker: OldLocation },
        { text: "Updated Location", marker: UpdatedLocation },
      ],
      legends: [
        { text: "Pickup location", marker: sourceMarker },
        { text: "Drop Location", marker: destinationsMarker },
      ],
      TripStatusCount: [],
    };
  },
  methods: {
    operationsMapInfo(tripStatus) {
      this.TripStatusCount = tripStatus;
    },

    plannedLocation() {
      this.isVisiblePlanned = !this.isVisiblePlanned;
      this.$emit("plannedLocation", this.isVisiblePlanned);
    },
    unplannedLocation() {
      this.isVisibleUnplanned = !this.isVisibleUnplanned;
      this.$emit("unplannedLocation", this.isVisibleUnplanned);
    },
    resetInfo() {
      this.isVisiblePlanned = true;
      this.isVisibleActual = true;
    },
    routeDisplay(typeOfRoute) {
      if (typeOfRoute == "planned") {
        this.isVisiblePlanned = !this.isVisiblePlanned;
        this.routeChanged({
          actual: this.isVisibleActual,
          planned: this.isVisiblePlanned,
        });
      } else {
        this.isVisibleActual = !this.isVisibleActual;
        this.routeChanged({
          actual: this.isVisibleActual,
          planned: this.isVisiblePlanned,
        });
      }
    },
    routeChanged({ actual, planned }) {
      if (this.referenceElement) {
        this.referenceElement.clearGeoJson();
        this.referenceElement.clearDriverRoute();
        if (actual && planned) {
          this.referenceElement.setDriverRoute(this.actualRoute);
          this.referenceElement.setPlannedRoute(this.plannedRoute);
        } else if (planned) {
          this.referenceElement.setPlannedRoute(this.plannedRoute);
        } else if (actual) {
          this.referenceElement.setDriverRoute(this.actualRoute);
        } else {
          this.referenceElement.clearDriverRoute();
          this.referenceElement.clearGeoJson();
        }
      }
    },
  },
};
</script>

<style>
.blue-box {
  border: 2.5px solid #0000ff57;
  background-color: #0000ff40;
}
.green-box {
  border: 2.5px solid red;
  background-color: #0080008f;
}
.yellow-box {
  border: 2.5px solid red;
  background-color: yellow;
}
.square-box {
  height: 15px;
  width: 15px;
}

.map-info-card {
  bottom: 20px;
  right: 5px;
}
</style>
